import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import EmptyState from './EmptyState';
import { ChevronLeftIcon } from './Icons';

/**
 * A detail page whose item does not exist (a 404) (#595): the text and a
 * link to the list. Another error of the load shows `ErrorState` with Retry.
 */
export default function NotFoundState({ icon, title, to, linkLabel }: {
  icon: ReactNode; title: string; to: string; linkLabel: string;
}) {
  return (
    <EmptyState icon={icon} title={title}
      action={<Link to={to} data-testid="not-found-list-link" className="btn-outline btn-sm"><ChevronLeftIcon className="w-4 h-4" />{linkLabel}</Link>} />
  );
}
